routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('profile', {
      url: '/profile/:username',
      template: require('./index.html'),
      controller: 'ProfileController',
      controllerAs: 'pc',
      authRequired: true
    });
}



// WEBPACK FOOTER //
// ./src/app/features/profile/routes.js